import React from 'react';
import { useLocation } from 'react-router-dom';
import '../styles/globalStyles.css';
import '../styles/topBarStyles.css';

const TopBar = () => {
  const location = useLocation();
  const isProjectPage = location.pathname.startsWith('/projects');

  return (
    <div className="topBar">
        <div className="nameLogoArea">
          <div className="nameContainer">altasyn</div>
          {isProjectPage && <div className="projectsLabel">PROJECTS</div>}
        </div>
        <div className="linksContainer">
          {/*
            <a href="/portfolio" style={{ margin: '0 15px', textDecoration: 'none', color: 'white' }}>Portfolio</a>
            <a href="/contact" style={{ margin: '0 15px', textDecoration: 'none', color: 'white' }}>Contact</a>
            <a href="/login" style={{ margin: '0 15px', textDecoration: 'none', color: 'white' }}>Login</a>
          */}
        </div>
    </div>
  );
};

export default TopBar;
